import React, { useEffect, useState } from "react";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography, Box, Checkbox } from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";
import MemberRow from "./MemberRow";
import data from "./data"; // You can move your data to a separate file 
import DateRowSkeleton from "./DateRowSkeleton";
import NoData from "../../../components/NoData/NoData";

const cellStyle = {
    padding: '10px 16px',
};

const AmountsOwedTable = () => {
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);  // Ensure this gets called
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    const handleSelectAll = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.map((row) => row.id));
        }
    };

    const handleRowToggle = (id) => () => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const allSelected = selectedRows.length === data.length;
    const someSelected = selectedRows.length > 0 && !allSelected;

    return (
        <>
            <Box display="flex" alignItems="center" gap={2} className="showSummaryCs" sx={{ padding: '0px 0 12px 0', }}>
                <Box component="li" sx={{ listStyle: 'none' }}>
                    <Typography variant="body2">
                        <Box component="span" fontWeight="400" sx={{ fontSize: '12px', background: '#004DFF', borderRadius: '50px', color: '#fff', padding: '6px 16px 6px 16px' }}>Tue, Apr 1, 2025</Box>
                    </Typography>
                </Box>
                <Box component="li" sx={{ listStyle: 'none' }}>
                    <Typography variant="body2" sx={{ color: '#9095A1', fontSize: '14px', }}>
                        Total time worked:
                        <Box component="span" fontWeight="bold" sx={{ color: '#373737', }}>8:01:13</Box>
                    </Typography>
                </Box>

                <Box component="li" sx={{ listStyle: 'none' }}>
                    <Typography variant="body2" sx={{ color: '#9095A1', fontSize: '14px', }}>
                        Total Amount :   <Box component="span" fontWeight="bold" sx={{ color: '#004DFF', }}>$355.10</Box>
                    </Typography>
                </Box>
            </Box>
            <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent', marginBottom: '24px' }}>
                <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 5px' }}>
                    <TableHead sx={{ backgroundColor: '#DFDFDF' }}>
                        <TableRow>
                            <TableCell sx={{
                                ...cellStyle,
                                border: 'none',
                                minWidth: '32px',
                                maxWidth: '32px',
                                borderTopLeftRadius: '10px',
                                borderBottomLeftRadius: '10px'
                            }}>
                                <CustomCheckbox
                                    checked={allSelected}
                                    indeterminate={someSelected}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>#</TableCell>
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Members</TableCell>
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Project</TableCell>
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Current rate</TableCell>
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Total hours</TableCell>
                            <TableCell sx={{
                                ...cellStyle,
                                border: 'none',
                                borderTopRightRadius: '10px',
                                borderBottomRightRadius: '10px',
                                textAlign: 'center',
                            }}>
                                Total Amount
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    {/* {loading
                            ? [...Array(3)].map((_, i) => <DateRowSkeleton key={i} />)
                            : data.map((row) => (
                                <MemberRow
                                    key={row.id}
                                    row={row}
                                    isSelected={selectedRows.includes(row.id)}
                                    onSelectToggle={handleRowToggle(row.id)}
                                />
                            ))} */}
                    <TableBody>
                        {loading ? (
                            [...Array(3)].map((_, i) => <DateRowSkeleton key={i} />)
                        ) : data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center" sx={{ padding: '40px 16px' }}>
                                    <NoData />
                                </TableCell>
                            </TableRow>
                        ) : (
                            data.map((row) => (
                                <MemberRow
                                    key={row.id}
                                    row={row}
                                    isSelected={selectedRows.includes(row.id)}
                                    onSelectToggle={handleRowToggle(row.id)}
                                />
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default AmountsOwedTable;